import React from "react";
import botAvatar from "../../assets/female_avatar.jpg";
import userAvatar from "../../assets/male_avatar.jpg";
interface AvatarProps {
    name: string;
    speaking?: boolean;
    background?: string;
    type: "user" | "bot";
    className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ name, type, speaking, className }) => {
    return (
        <div
            className={`flex h-[150px] w-[150px] flex-col items-center justify-center gap-4 rounded-3xl border border-transparent bg-white/10 p-4 shadow-sm transition-all lg:h-[170px] lg:w-full ${speaking && "border-green-400"} ${className && className}`}
        >
            <img src={type === "bot" ? botAvatar : userAvatar} className="h-[70%] w-auto rounded-full" />
            <span className="block truncate text-sm font-semibold capitalize">{name}</span>
        </div>
    );
};

export default Avatar;
